import styled from 'styled-components';
import Image from '@components/Image';

const StyledImage = styled(Image)`
  max-width: 64px;
  height: 82px;
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
`;

export default StyledImage;
